import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteLayout } from "./components/layout/SiteLayout";
import { PageMeta } from "./components/shared/PageMeta";
// Homepage sections: imported and rendered in EXACT visual order (Magic-to-Bricks contract).
import { Hero } from "./components/sections/Hero";
import { TrustBar } from "./components/sections/TrustBar";
import { OwnerStory } from "./components/sections/OwnerStory";
import { Testimonials } from "./components/sections/Testimonials";
import { CtaBand } from "./components/sections/CtaBand";
import { BuildPathways } from "./components/sections/BuildPathways";
import { DesignDiscovery } from "./components/sections/DesignDiscovery";
import { RealProjects } from "./components/sections/RealProjects";
import { BuildingJourney } from "./components/sections/BuildingJourney";
import { InclusionsClarity } from "./components/sections/InclusionsClarity";
import { FaqSection } from "./components/sections/FaqSection";
import { PlanningGuide } from "./components/sections/PlanningGuide";
import { ConsultationSection } from "./components/sections/ConsultationSection";
// Interior pages
import { HomeDesigns } from "./pages/HomeDesigns";
import { DesignDetail } from "./pages/DesignDetail";
import { Projects } from "./pages/Projects";
import { About } from "./pages/About";
import { OurProcess } from "./pages/OurProcess";
import { Contact } from "./pages/Contact";
import { NotFound } from "./pages/NotFound";
type AppProps = {
  heroEmphasis?: "consultation-first" | "design-first";
  heroHeadline?: "next-home" | "owners-money";
  showAssistant?: boolean;
};
export function App({
  heroEmphasis = "consultation-first",
  heroHeadline = "next-home",
  showAssistant = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="nvj3xh1mugq9">
      <Routes data-id="element-1" data-mp="nw2egcoye2u9">
        <Route element={<SiteLayout showAssistant={showAssistant} data-id="element-3" data-mp="nv0ybtt2yq5o" />} data-id="element-2" data-mp="nuhicimzqbua">
          <Route index element={<>
                <PageMeta title="New & Custom Home Builders Perth | Oceanside Living" description="Owner-led Perth home builders for your next home: single-storey designs, knock-down/rebuilds, rear-block homes, custom builds and investments. Book a consultation." data-id="element-5" data-mp="swgi7ijiuqmh" />
                <Hero emphasis={heroEmphasis} headline={heroHeadline} data-id="element-6" data-mp="85ully910b6z" />
                <TrustBar data-id="element-7" data-mp="83qgjcze5654" />
                <OwnerStory data-id="element-8" data-mp="3gkv17sr2xrdt" />
                <Testimonials data-id="element-9" data-mp="3gm64zskiyz4x" />
                <CtaBand data-id="element-10" data-mp="3gja7u6gi4ehj" />
                <BuildPathways data-id="element-11" data-mp="3bmjqlfsyncuj" />
                <DesignDiscovery data-id="element-12" data-mp="3bncorsdusu12" />
                <RealProjects data-id="element-13" data-mp="3bk70gfd1tw6e" />
                <BuildingJourney data-id="element-14" data-mp="3qaxtfqqdn1b3" />
                <InclusionsClarity data-id="element-15" data-mp="3qbzg6sgr9c8n" />
                <FaqSection data-id="element-16" data-mp="3qdafog363xty" />
                <PlanningGuide data-id="element-17" data-mp="3ljxvci5iud70" />
                {/* Advice preview omitted: no approved articles exist yet. */}
                <ConsultationSection data-id="element-18" data-mp="2xu3i3zhaimm8" />
              </>} data-id="element-4" data-mp="sudoanf90dch" />
          <Route path="home-designs" element={<HomeDesigns data-id="element-20" data-mp="2suqv9eqf5fjn" />} data-id="element-19" data-mp="2sw207hvlotcc" />
          <Route path="home-designs/:slug" element={<DesignDetail data-id="element-22" data-mp="18d9e69sxtqtr" />} data-id="element-21" data-mp="2svjyw6u2zoxk" />
          <Route path="projects" element={<Projects data-id="element-24" data-mp="18bokemeg6bwy" />} data-id="element-23" data-mp="18czn0iw5pdmh" />
          <Route path="about" element={<About data-id="element-26" data-mp="1d5jbwc0anv6l" />} data-id="element-25" data-mp="1d47wfexhkyzn" />
          <Route path="our-process" element={<OurProcess data-id="element-28" data-mp="1d6atgix23sdv" />} data-id="element-27" data-mp="1d62gys4uip37" />
          <Route path="contact" element={<Contact data-id="element-30" data-mp="ygwodn0ijx4a" />} data-id="element-29" data-mp="yg3kctsxvlpu" />
          <Route path="*" element={<NotFound data-id="element-32" data-mp="13eexbdej6cca" />} data-id="element-31" data-mp="ydik298ahdu7" />
        </Route>
      </Routes>
    </BrowserRouter>;
}